import { ISelectItem } from '@lla-platform/core/core-ui'

export enum PreferredVendorLevel {
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3 = 'Level3'
}

export const PreferredVendorLevelToLabel: Record<string, string> = {
  Level1: 'Level 1',
  Level2: 'Level 2',
  Level3: 'Level 3'
}

export const PreferredVendorLevelItems: ISelectItem[] = Object.values(PreferredVendorLevel).map(
  (value) => ({
    label: PreferredVendorLevelToLabel[value],
    value
  })
)
